import React from "react";
import { useTranslation } from "react-i18next";

type InlineLoaderSize = "sm" | "md" | "lg";

interface InlineLoaderProps {
  message?: string;
  className?: string;
  size?: InlineLoaderSize;
}

const spinnerSizeClasses: Record<InlineLoaderSize, string> = {
  sm: "w-5 h-5 border-2",
  md: "w-8 h-8 border-2",
  lg: "w-12 h-12 border-4",
};

const textSizeClasses: Record<InlineLoaderSize, string> = {
  sm: "text-xs mt-1.5",
  md: "text-sm mt-2",
  lg: "text-base mt-3",
};

const paddingClasses: Record<InlineLoaderSize, string> = {
  sm: "p-4",
  md: "p-6",
  lg: "p-8",
};

export const InlineLoader: React.FC<InlineLoaderProps> = ({
  message,
  className = "",
  size = "md",
}) => {
  const { t } = useTranslation();

  return (
    <div className={`text-center card-base ${paddingClasses[size]} ${className}`}>
      <div
        className={`mx-auto rounded-full animate-spin border-primary-500 border-b-transparent ${spinnerSizeClasses[size]}`}
      />
      <p className={`text-neutral-600 ${textSizeClasses[size]}`}>
        {message ?? t("common.loading")}
      </p>
    </div>
  );
};
